export const searchInAllFields = <T extends object>(searchQuery: string, itemsToSearch: T[]) => {
  searchQuery = searchQuery.toLowerCase();

  if (searchQuery.length) {
    return itemsToSearch.filter((c) => Object.values(c).some((v) => v?.toString().toLowerCase().includes(searchQuery)));
  } else {
    return itemsToSearch;
  }
};
